export default __webpack_public_path__ + "static/sprite-db4ffba24578bb57675dc6bc2671ce4f.svg";